window.addEventListener('alpine:init', () => {
  if (window.global.registeredAlpineComponents['productMain']) return;

  var {
    getElFromHtmlString,
    removeSectionWrapper,
    scrollIntoViewWithinEl,
    getDefaultAlpineMorphLifecycleHooks
  } = Alpine.store('utilities');

  var defaultAlpineMorphLifecycleHooks = getDefaultAlpineMorphLifecycleHooks();

  function productMain(data = {}) {
    return {
      ...data,

      isLoadingProductMain: false,

      isVariantUnavailable: false,

      sellingPlansRadioValue: null,

      selectedVariantId: +(new URL(location).searchParams.get('variant')),

      selectedSellingPlanId: +(new URL(location).searchParams.get('selling_plan')),

      isStickyFormVisible: false,

      init() {
        this.onProductFormSubmitStart = this.onProductFormSubmitStart.bind(this);
        this.onProductFormSubmitEnd = this.onProductFormSubmitEnd.bind(this);
        this.onProductFormChange = this.onProductFormChange.bind(this);

        window.addEventListener('productformsubmitstart', this.onProductFormSubmitStart);
        window.addEventListener('productformsubmitend', this.onProductFormSubmitEnd);
        window.addEventListener('productformchange', this.onProductFormChange);

        this.$watch('selectedSellingPlanId', () => {
          if (this.selectedSellingPlanId) {
            this.sellingPlansRadioValue = true;
          } else {
            this.sellingPlansRadioValue = false;
          }
        });
      },

      destroy() {
        window.removeEventListener('productformsubmitstart', this.onProductFormSubmitStart);
        window.removeEventListener('productformsubmitend', this.onProductFormSubmitEnd);
        window.removeEventListener('productformchange', this.onProductFormChange);
      },

      onProductFormSubmitStart() {
        this.isLoadingProductMain = true;
      },

      onProductFormSubmitEnd() {
        this.isLoadingProductMain = false;
      },

      onProductFormChange(event) {
        this.renderAndUpdateUrl({
          selectedOptionValues: event.detail.selectedOptionValues,
          selectedSellingPlanId: event.detail.selectedSellingPlanId
        });
      },

      renderAndUpdateUrl({
        baseUrl = location,
        selectedOptionValues,
        selectedSellingPlanId = this.selectedSellingPlanId
      }) {
        this.isLoadingProductMain = true;

        var sectionUrl = new URL(baseUrl);

        sectionUrl.searchParams.set('section_id', this.sectionId);

        if (selectedOptionValues) {
          sectionUrl.searchParams.set('option_values', selectedOptionValues.join(','));
        }

        if (selectedSellingPlanId) {
          sectionUrl.searchParams.set('selling_plan', selectedSellingPlanId);
        }

        fetch(sectionUrl)
          .then((res) => res.text())
          .then((res) => {
            var sectionHtml = removeSectionWrapper(res);

            var sectionIdEl = getElFromHtmlString(res, '[name="id"]');

            var url = new URL(baseUrl);

            if (sectionIdEl.value) {
              url.searchParams.set('variant', sectionIdEl.value);
              this.selectedVariantId = +(sectionIdEl.value);
              this.isVariantUnavailable = false;
            } else {
              url.searchParams.delete('variant');
              this.selectedVariantId = null,
              this.isVariantUnavailable = true;
            }

            if (sectionIdEl.value && selectedSellingPlanId) {
              url.searchParams.set('selling_plan', selectedSellingPlanId);
              this.selectedSellingPlanId = selectedSellingPlanId;
            } else {
              url.searchParams.delete('selling_plan');
              this.selectedSellingPlanId = null;
            }

            window.history.replaceState(null, null, url);

            Alpine.morph(this.$root, sectionHtml, defaultAlpineMorphLifecycleHooks);

            dispatchEvent(new CustomEvent('productmainrendersuccess', {
              detail: {
                variantId: +(sectionIdEl.value)
              }
            }));
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.isLoadingProductMain = false;
          });
      },

      scrollToSelectedMedia({ selectedVariantId = this.selectedVariantId, variantIds, behavior }) {
        if (variantIds.includes(selectedVariantId)) {
          scrollIntoViewWithinEl(this.$el, behavior);
        }
      }
    };
  };

  Alpine.data('productMain', productMain);

  window.global.registeredAlpineComponents['productMain'] = true;
});
